<template>
  <vs-row>
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
        <vs-card style="border-radius: 1.5em;">
          <div slot="header">
            <h3 class="card-title mb-0">Información de filtro</h3>
          </div>
          <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <!-- Selector de empresa -->
              <company-selector v-model="companyId"/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Fecha inicial</label>
              <vs-input type="date" v-model="initialDate" class="w-100 "/>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Fecha final</label>
              <vs-input type="date" v-model="finalDate" class="w-100 "/>
            </vs-col>
          </vs-row>
          <br/>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
              <label class="vs-input--label">Número de factura</label>
              <vs-input type="text" v-model="searchBillNumber" class="w-100 "/>
            </vs-col>
          </vs-row>
          <hr class="custom-hr"/>
          <div class="d-inline-block d-md-flex align-items-center">
            <div class="btn-alignment">
              <vs-button @click="listPreview()">Buscar</vs-button>
              <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
            </div>
            <div class="ml-auto mt-3 mt-md-0">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                  <vs-button class="btnx" type="filled" color="danger"
                             @click="downloadReport()">
                    <i class="ti-upload mr-2"></i>Exportar
                  </vs-button>

                  <vs-dropdown>
                    <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                    <vs-dropdown-menu>
                      <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                 :value="document.id" :key="document.id"
                                 :id="document.id" @click="formatType=document.id">{{ document.name }}
                      </vs-button>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </div>
          </div>
        </vs-card>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
        <div style="max-height: 25em; overflow-y: auto;">
          <vs-card style="border-radius: 1.5em;">
            <h3 class="card-title d-flex">
              Tabla de previsualización
            </h3>
            <vs-table
                :data="tableData"
                :max-items="50"
                pagination>
              <template slot="header">
              </template>
              <template slot="thead">
                <vs-th sort-key="billNumber">Número de factura</vs-th>
                <vs-th sort-key="prefix">Prefijo</vs-th>
                <vs-th sort-key="instant">Total factura</vs-th>
                <vs-th sort-key="tax">Fecha de emisión</vs-th>
                <vs-th sort-key="subtotal">Usuario de anulación</vs-th>
                <vs-th sort-key="total">Fecha de anulación</vs-th>
                <vs-th sort-key="total">Descripción de la anulación de la factura</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].invoiceNumber">
                    {{ data[indextr].invoiceNumber }}
                  </vs-td>
                  <vs-td :data="data[indextr].prefix">
                    {{ data[indextr].prefix }}
                  </vs-td>
                  <vs-td :data="data[indextr].totalPaid">
                    {{ data[indextr].totalPaid }}
                  </vs-td>
                  <vs-td :data="data[indextr].creationDate">
                    {{ data[indextr].creationDate }}
                  </vs-td>
                  <vs-td :data="data[indextr].cancellationUser">
                    {{ data[indextr].cancellationUser }}
                  </vs-td>
                  <vs-td :data="data[indextr].cancellationDate">
                    {{ data[indextr].cancellationDate }}
                  </vs-td>
                  <vs-td :data="data[indextr].cancellationDescription">
                    {{ data[indextr].cancellationDescription }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </div>
      </vs-col>
    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";
import toast from "@/global/ToastConfig";
import DateUtils from "@/global/DateUtils";
import downloadEndpoint from "@/endpoints/download/downloadEndpoint";

export default {
  components: {CompanySelector},
  data() {
    return {
      initialDate: null,
      finalDate: null,
      companyId: null,
      isLoading: false,
      showTable: false,
      tableData: [],
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      searchBillNumber: null,
    }
  },
  watch: {
    /**
     * Observa el companyId y realiza una accion si este cambia
     */
    companyId() {
      this.showTable = false;
      this.tableData = [];
      this.page = 1;
    },
    /**
     * Observa el initialDate y realiza una accion si este cambia
     */
    initialDate() {
      this.showTable = false;
      this.tableData = [];
      this.page = 1;
    },
    /**
     * Observa el finalDate y realiza una accion si este cambia
     */
    finalDate() {
      this.showTable = false;
      this.tableData = [];
      this.page = 1;
    },
    searchBillNumber() {
      this.tableData = [];
      this.page = 1;
    },
  },
  methods: {
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.showTable = false;
      this.tableData = [];
    },
    /**
     * metodo que valida  el fromulario de busqueda
     */
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar  la fecha inicial y/o  la fecha final");
      }
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error(" La fecha final no puede ser inferior a la fecha inicial");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañía");
      }
    },
    /**
     * Metodo que asigna los parametros para descarga y previsualizacion del reporte
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
        billsNumber: this.searchBillNumber
      }
    },
    /**
     * descarga del reporte
     */
    downloadReport() {
      try {
        this.isLoading = true;
        toast.info('Cargando reporte');
        this.validateForm();
        const params = this.prepareParameters();
        parkingReportsEndpoints.downloadCancellationInvoice(params)
            .then(data => {
              if (data.code <= 0) {
                this.isLoading = false;
                return;
              }
              downloadEndpoint.downloadFile(data.info);
              this.isLoading = false;
            })

      } catch (error) {
        toast.error(error.message)
        this.isLoading = false;
      }

    },
    /**
     * previsualización del reporte
     */
    listPreview() {
      try {
        this.isLoading = true;
        this.validateForm();
        const params = this.prepareParameters();
        parkingReportsEndpoints.previewCancellationInvoice(params)
            .then(data => {
              if (data.code === 0) {
                this.tableData = [];
                this.isLoading = false;
                this.showTable = false;
              }
              this.isLoading = false;
              this.tableData = data.info;
              this.showTable = true;
            })
      } catch (error) {
        toast.error(error.message)
        this.isLoading = false;
      }
    },

  }

}
</script>